import {assert} from 'Asserts';
import {RowDataUiData} from 'notebook/tables/TableConstants';

import {LiveRowMetadata, StructuredTable, StructuredTableRow} from '../StructuredTableConstants';

/**
 * buildRowUiData holds the logic to parse the information that isn't persisted in the table but is instead used to
 * decorate the row with additional UI information.  An example of this is the `archivePurpose` which is used
 * to show a vertical bar in the row
 *
 * @param structuredTable Table to build the rowUIData for, also uses the lastSyncedArchivePurpose on the row
 * as a fallback if the liveRowMetadata is not available
 * @param liveRowMetadataByRow The live row metadata for each row in the table, may not be present if the
 * fetch has not been completed
 * @param structuredTableRowsBatch The subset of rows of structuredTable
 * to consider, useful for batched and row-based table submission.
 * If not provided, use structuredTable.rows instead.
 * @returns Returns an array of RowDataUiData objects that contain rendering information for each row
 */
export default function buildRowUiData(
  structuredTable: StructuredTable<unknown, unknown>,
  liveRowMetadataByRow?: Array<LiveRowMetadata>,
  structuredTableRowsBatch?: Array<StructuredTableRow<unknown>>
): Array<RowDataUiData> {
  const structuredTableRows = structuredTableRowsBatch || structuredTable.rows;
  assert(
    !liveRowMetadataByRow || structuredTableRows.length === liveRowMetadataByRow.length,
    'Length of StructuredTable rows and LiveRowMetadata rows are not equal'
  );
  return structuredTableRows.map((row: StructuredTableRow<unknown>, rowIndex: number) => ({
    archivePurpose:
      liveRowMetadataByRow && liveRowMetadataByRow[rowIndex].archivePurpose
        ? liveRowMetadataByRow[rowIndex].archivePurpose
        : row.lastSyncedArchivePurpose,
  }));
}
